
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scoreranking",
      function () {
        return require("private-next-pages/scoreranking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scoreranking"])
      });
    }
  